import ApiService from "@/core/services/api.service";

// action types
export const GET_HOME_DATA = "getHomeData";
export const GET_QUESTION_DATA = "getQuestionData";

// mutation types
export const SET_HOME_DATA = "setHomeData";
export const SET_QUESTION_DATA = "setQuestionData";
export const SET_ERROR = "setError";

const state = {
    errors: null,
    homeData: {},
    questionData: {},
};

const getters = {
    homeData(state) {
        return state.homeData;
    },
    questionData(state) {
        return state.questionData;
    }
};

const actions = {
    [GET_HOME_DATA](context, params) {
        return new Promise((resolve, reject) => {
            ApiService.post("lessons/", params)
                .then(({ data }) => {
                    console.log(data.data.lessons);
                    context.commit(SET_HOME_DATA, data.data.lessons);
                    resolve(data);
                })
                .catch(({ response }) => {
                    context.commit(SET_ERROR, response.data.message);
                    reject(response);
                });
        });
    },
    [GET_QUESTION_DATA](context, lesson) {
        return new Promise((resolve, reject) => {
            ApiService.get("lessons/" + lesson + "/questions")
                .then(({ data }) => {
                    context.commit(SET_QUESTION_DATA, data.data);
                    resolve(data);
                })
                .catch(({ response }) => {
                    context.commit(SET_ERROR, response.data.message);
                    reject(response);
                });
        });
    },
};

const mutations = {
    [SET_HOME_DATA](state, data) {
        state.homeData = data;
    },
    [SET_QUESTION_DATA](state, data) {
        state.questionData = data;
    },
    [SET_ERROR](state, error) {
        state.errors = [];
        state.errors.push(error);
    },
};

export default {
    state,
    actions,
    mutations,
    getters
};